import { motion } from "framer-motion";

export default function EnhancedLogo() {
  return (
    <div className="relative flex justify-center mb-10">
      {/* Sparkling Stars Animation */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="animate-sparkle absolute w-2 h-2 bg-white rounded-full top-4 left-4 opacity-70 blur-sm"></div>
        <div className="animate-sparkle animation-delay-2000 absolute w-1.5 h-1.5 bg-blue-300 rounded-full top-10 right-6 opacity-60 blur-sm"></div>
        <div className="animate-sparkle animation-delay-4000 absolute w-1 h-1 bg-yellow-200 rounded-full bottom-6 left-12 opacity-50 blur-sm"></div>
      </div>

      <motion.div
        whileHover={{ scale: 1.08 }}
        className="relative bg-gradient-to-r from-purple-600 to-indigo-600 p-4 rounded-2xl shadow-2xl transition-all duration-300 hover:shadow-indigo-500/40 border border-white/10"
      >
        <div className="shine-effect absolute inset-0 rounded-2xl pointer-events-none"></div>

        <img
          src="./Images/logos/google-adx-logo-1-1.png"
          className="h-16 md:h-20 lg:h-24 object-contain max-w-full drop-shadow-lg"
          alt="Google AdX Logo"
        />
        <p className="text-white text-center mt-2 font-semibold">Google BidExchange</p>
      </motion.div>
    </div>
  );
}
